import { MatchDetailItemFragment } from '@amf/shared/types/graphql';
import classNames from 'classnames';
import useMatch from '@amf/shared/components/match/hooks/useMatch';

type Props = {
  match: MatchDetailItemFragment;
};

function MatchJumbotronTimer({ match }: Props) {
  const { match: live } = useMatch(match.id, match.live);
  const isMatchPaused = match.paused || !match.started || match.ended;

  if (!live || !live.timer) return null;
  return (
    <div
      className={classNames('MatchJumbotron__timer', {
        'MatchJumbotron__timer--active': !isMatchPaused,
      })}
    >
      {live.timer}
    </div>
  );
}

export default MatchJumbotronTimer;
